import {
  Button,
  ButtonIconPosition,
  ButtonSize,
  ButtonVariant,
} from "@amzn/stencil-react-components/button";
import { Col, View } from "@amzn/stencil-react-components/layout";
import { Text } from "@amzn/stencil-react-components/text";
import IconMessageExtraSmall from "@amzn/stencil-react-icons/icons/icon-message-extra-small";
import { useIntl } from "react-intl";

/**
 * Offer to hand off to a live support engineer, shown after the last turn.
 *
 * Sits just outside the transcript's aria-live region: it is interactive, and
 * anything inside that region gets re-announced every time a reply streams in.
 */
export const NeedMoreHelp = ({
  onChat,
}: {
  onChat: () => void;
}): JSX.Element => {
  const intl = useIntl();

  return (
    <View
      backgroundColor="color.surface.bg-default"
      border="1px solid color.border.primary"
      borderRadius="dimensions.border.radius.200"
      padding="S400"
      dataTestId="chatbotNeedMoreHelp"
    >
      {/* Button sits on its own line below the message and hugs its label. */}
      <Col gridGap="S300" alignItems="flex-start">
        <Text fontSize="T200" color="color.text.primary">
          {intl.formatMessage({ id: "chatbot-need-more-help" })}
        </Text>
        <Button
          variant={ButtonVariant.Secondary}
          size={ButtonSize.Small}
          icon={<IconMessageExtraSmall aria-hidden />}
          iconPosition={ButtonIconPosition.Leading}
          onClick={onChat}
          dataTestId="chatbotContactSupport"
        >
          {intl.formatMessage({ id: "chatbot-chat-with-support" })}
        </Button>
      </Col>
    </View>
  );
};
